import { Ulid } from 'id128'

export const generateUuid = () => {
  const ulid = Ulid.generate().toRaw().toLowerCase()
  return `${ulid.slice(0, 8)}-${ulid.slice(8, 12)}-${ulid.slice(
    12,
    16
  )}-${ulid.slice(16, 20)}-${ulid.slice(20)}`
}
